"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.PrefillsResidentAccountCreateSuccAnalyticsEvent = exports.PrefillsResidentAccountCreateFailAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when the Onboarding Create Account Resident Prefill successfully completes and the prefilled Create Account form is mounted
 */
var PrefillsResidentAccountCreateSuccAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('prefills_resident_account_create_succ');
exports.PrefillsResidentAccountCreateSuccAnalyticsEvent = PrefillsResidentAccountCreateSuccAnalyticsEvent;
/**
 * Triggers when the Onboarding Create Account Resident Prefill fails and the Create Account form is mounted without any prefilled data
 */
var PrefillsResidentAccountCreateFailAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('prefills_resident_account_create_fail');
exports.PrefillsResidentAccountCreateFailAnalyticsEvent = PrefillsResidentAccountCreateFailAnalyticsEvent;
